/* PROD */
export const HOST_MANAGER = 'https://jr-prod-manager-d0cd2253.azurewebsites.net'
export const HOST_WEB = 'https://jr-prod-webapp-api-ed002e70.azurewebsites.net'
export const HOST_EXPERIENCE = 'https://experience.jellyride.com'


export const BASE_URL = `${HOST_MANAGER}/api`
export const BASE_URL1 = `${HOST_WEB}/webapi`
export const BASE_MEDIA = `${HOST_WEB}/media`
export const BASE_PUBLIC = `${HOST_WEB}/public`
export const BASE_PAYMENT = `${HOST_WEB}/payment`

export const BASE_ESHOP = `${HOST_EXPERIENCE}/store`
export const BASE_REVIEW = `${HOST_EXPERIENCE}/review`

export const BASE_STORAGE = 'https://jr-storage-cdn-prod.azureedge.net'

/* DEMO */
/* export const BASE_URL = 'https://jr-demo-manager-8490df41.azurewebsites.net/api'
export const BASE_URL1 = 'https://enlight-demo.azurewebsites.net/webapi'
export const BASE_MEDIA = 'https://enlight-demo.azurewebsites.net/media'
export const BASE_PUBLIC = 'https://enlight-demo.azurewebsites.net/public'
export const BASE_PAYMENT = 'https://enlight-demo.azurewebsites.net/payment'
export const BASE_STORAGE = 'https://jrdemostorage8684e483.blob.core.windows.net'

export const BASE_ESHOP = 'https://experience.jellyride.fun/store'
export const BASE_REVIEW = 'http://experience.jellyride.fun/review' */

/* PROD */
/* export const BASE_URL = 'https://jr-prod-manager-d0cd2253.azurewebsites.net/api'
export const BASE_URL1 = 'https://jr-prod-webapp-api-ed002e70.azurewebsites.net/webapi'
export const BASE_MEDIA = 'https://jr-prod-webapp-api-ed002e70.azurewebsites.net/media'
export const BASE_PUBLIC = 'https://jr-prod-webapp-api-ed002e70.azurewebsites.net/public'
export const BASE_PAYMENT = 'https://jr-prod-webapp-api-ed002e70.azurewebsites.net/payment' */

//export const BASE_STORAGE = 'https://jrprodstorage6fb394dd.blob.core.windows.net'

//export const BASE_ESHOP = 'https://experience.jellyride.com/store'
//export const BASE_REVIEW = 'https://experience.jellyride.com/review'
